module.exports = __webpack_public_path__ + "img/36070-2-34.prt.c322df4e.jpg";